import React from 'react';
import PropTypes from 'prop-types';

const SettingsPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M23.95 20.35l1.8 3.15-2.25 2.25-3-1.8-1.95.75L17.5 28h-3l-1.05-3.3-1.95-.75-3 1.8-2.25-2.25 1.8-3.15-.75-1.8L4 17.5v-3l3.3-1.05.75-1.8-1.8-3.15L8.5 6.25l3 1.8L13.75 7l.75-3h3l.75 3 2.25.75 3-1.5 2.25 2.25-1.8 3.15.75 1.8L28 14.5v3l-3.3 1.05-.75 1.8zM16 20.154c1.108 0 2.077-.416 2.908-1.246.83-.831 1.246-1.8 1.246-2.908 0-.554-.139-1.108-.277-1.662-.277-.415-.554-.969-.97-1.246-.276-.415-.83-.692-1.245-.969-.554-.138-1.108-.277-1.662-.277-1.108 0-2.077.416-2.908 1.246-.83.831-1.246 1.8-1.246 2.908 0 1.108.416 2.077 1.246 2.908.831.83 1.8 1.246 2.908 1.246z"
    />
  );
};

SettingsPath.propTypes = {
  fill: PropTypes.string,
};

export default SettingsPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/settings.jsx